import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { globalActions, userActions, useStore } from '@modules';
import { VerifyNextEnum } from '@modules/types';

import Button from '@components/Button';
import Captcha from '@components/Captcha';
import MainLayout from '@layouts/MainLayout';

import style from './OldEmail.scss';

const cn = bemCssModules(style, 'OldEmail');

const OldEmail: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation<LocationStateType['verification']>();
  const { state } = location;
  const [{ user, global }, dispatch] = useStore();
  const email = user.data?.email || '';
  const { isShowCaptcha, captcha } = global;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = event => {
    event.preventDefault();
    if (isShowCaptcha) dispatch(globalActions.setShowCaptcha(false));

    dispatch(userActions.changeEmailSendOldEmail({ ...(captcha ? { captcha } : {}) }))
      .unwrap()
      .then(({ data }) => {
        if (data.next === VerifyNextEnum.verifyOldEmail) {
          const strongPassword = !!state?.strongPassword;
          const nextPage = CONST.nav.profileEdit;

          navigate<'verifications'>(CONST.nav.verification, {
            state: {
              strongPassword,
              flow: 'changeEmailVerifyOldEmail',
              nextPage,
            },
          });
        }
      })
      .catch(err => err);
  };

  const isLoading = !!user.loaders.changeEmailSendOldEmail;

  const onBack = () => navigate(CONST.nav.profileEdit);

  return (
    <MainLayout className={cn(null, [className])} backButton={onBack}>
      <div className={cn('content')}>
        <h1 className={cn('title')}>{t('old_email.header')}</h1>
        <div className={cn('description')}>{t('old_email.description', { email })}</div>
        <Button className={cn('button')} isLoading={isLoading} onClick={handleClick}>
          {t('old_email.send')}
        </Button>
        {isShowCaptcha && <Captcha className={cn('captcha')} />}
      </div>
    </MainLayout>
  );
};

export default OldEmail;
